'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Gift, Users, CalendarCheck } from 'lucide-react';
const benefits = [{
  icon: Gift,
  text: 'Free & discounted products for your people'
}, {
  icon: Users,
  text: 'Boost morale with fun brand experiences'
}, {
  icon: CalendarCheck,
  text: 'Seamless pop-ups, sampling & drop-offs'
}];
export function HostAtYourPlaceSection() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">Host experiences at your place</h2>;
    t1 = <p className="text-lg text-gray-500 mb-10 max-w-xl mx-auto">Brands want real people to try their products. Offer your office, campus, or public venue as a testing ground and unlock free samples, pop-ups, and activations for your team.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">{benefits.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-16 lg:py-16"><div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="max-w-3xl mx-auto text-center">{t0}{t1}{t2}<div className="text-center mt-12"><Link href="/for-places" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-600 text-white font-semibold shadow-md hover:bg-primary-700 hover:shadow-lg transition-all duration-200 cursor-pointer">Learn more about Sizzle for Places</Link></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(benefit) {
  return <div key={benefit.text} className="flex items-center gap-2 text-gray-700"><benefit.icon className="h-5 w-5 text-blue-600 flex-shrink-0" /><span className="text-sm font-medium">{benefit.text}</span></div>;
}